(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pj-clips"]) return;
  try {
    
  (() => {
    const init = (root) => {
      if (root.dataset.pjReady) return;
      root.dataset.pjReady = '1';
      const track = root.querySelector('.pj-clips__track');
      const dots = [...root.querySelectorAll('.pj-clips__dots i')];
      const items = track ? [...track.children] : [];
      if (track && dots.length && items.length > 1) {
        track.addEventListener('scroll', () => {
          const step = (items[1].offsetLeft - items[0].offsetLeft) || 1;
          const atEnd = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
          const i = atEnd ? items.length - 1 : Math.round(track.scrollLeft / step);
          dots.forEach((d, j) => d.classList.toggle('on', j === i));
        }, { passive: true });
      }
      const vids = [...root.querySelectorAll('video')];
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        vids.forEach((v) => { v.removeAttribute('autoplay'); v.pause(); v.controls = true; });
        return;
      }
      // Only play what is on screen, to save battery and data on phones.
      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver((entries) => entries.forEach((e) => {
          const v = e.target;
          if (e.isIntersecting) { const p = v.play(); if (p && p.catch) p.catch(() => {}); } else { v.pause(); }
        }), { threshold: 0.25 });
        vids.forEach((v) => io.observe(v));
      }
    };
    const run = () => document.querySelectorAll('[data-pj-clips]').forEach(init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
    document.addEventListener('shopify:section:load', run);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pj-kit"]) return;
  try {
    
  (() => {
    // "Get the kit": choose that option in the buy box, then bring the buy box into view.
    document.addEventListener('click', (e) => {
      const a = e.target.closest && e.target.closest('[data-pj-pick]');
      if (!a) return;
      const tiles = [...document.querySelectorAll('.bundle-ladder__tile')];
      const tile = tiles[Number(a.dataset.pjPick)];
      if (!tile) {
        // No bundle ladder on this page: bring the package tiles into view instead, if there are any.
        const packages = document.querySelector('.pjp');
        if (!packages) return;
        e.preventDefault();
        packages.style.scrollMarginTop = '84px';
        packages.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
        return;
      }
      e.preventDefault();
      const radio = tile.querySelector('.bundle-ladder__radio');
      if (radio && !radio.disabled) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      }
      tile.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
